import { render, staticRenderFns } from "./AppInfoField.vue?vue&type=template&id=51c4d59c&scoped=true&"
import script from "./AppInfoField.vue?vue&type=script&lang=js&"
export * from "./AppInfoField.vue?vue&type=script&lang=js&"
import style0 from "./AppInfoField.vue?vue&type=style&index=0&id=51c4d59c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c4d59c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
